import { toastr } from 'react-redux-toastr';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { LEGAL_MANIFEST_BAGGAGE_ENDPOINT } from '../../config/endpoints';
import { getBaggageManifest } from '../itinerary';
import { printBaggageManifest } from '../../utils/printers/BaggageManifest';

const getLegalManifestBaggageDetail = async (idSourceSystem) => async () => {
  try {
    const response = await fetch(`${LEGAL_MANIFEST_BAGGAGE_ENDPOINT}/${idSourceSystem}/detail`, {
      ...DEFAULT_GET_CONFIG
    });
    return await response.json();
  } catch (error) {
    toastr.error('Error', error.message);
    return []
  }
}

const generateManifestBaggageFile = async ({ itineraryId, serviceTypeName }) => async (dispatch) => {
  try {
    const manifest = await dispatch(getBaggageManifest({ itineraryId }))
    manifest.itineraryId = itineraryId;
    manifest.serviceTypeName = serviceTypeName;
    manifest.user = '-';
    printBaggageManifest(manifest);
  } catch (error) {
    toastr.error('Error', error.message);
  }
}

export {
  getLegalManifestBaggageDetail,
  generateManifestBaggageFile
}